const getLoginUrl = ({ success, password, google, facebook, apple }) => {
  if (!success) return 'register'
  if (password) return 'login'
  if (google) return 'login/google'
  if (facebook) return 'login/facebook'
  if (apple) return 'login/apple'
}

const getStagetId = ({ path }) => {
  const stepAcronym = {
    login: '#step-signin',
    register: '#step-signup',
    'login/google': '#step-google',
    'login/facebook': '#step-facebook',
    'login/apple': '#step-apple'
  }

  return stepAcronym[path]
}

const isLoginWithPassword = ({ success, password }) => {
  return !success || password
}

export { getLoginUrl, getStagetId, isLoginWithPassword }
